export const getListener = ({ isWrappedText, wrapperRef, tooltipRef, }) => {
    if (isWrappedText) {
        return (e) => {
            if (wrapperRef.current && tooltipRef.current) {
                const isTextWrapped = wrapperRef.current.clientWidth < wrapperRef.current.scrollWidth;
                if (isTextWrapped) {
                    tooltipRef.current.style.left = `${e.clientX + 10}px`;
                    tooltipRef.current.style.top = `${e.clientY + 15}px`;
                }
                else {
                    tooltipRef.current.style.visibility = 'hidden';
                }
            }
        };
    }
    return (e) => {
        if (wrapperRef.current && tooltipRef.current) {
            tooltipRef.current.style.left = `${e.clientX + 10}px`;
            tooltipRef.current.style.top = `${e.clientY + 15}px`;
        }
    };
};
//# sourceMappingURL=getListener.js.map